import type { FilterModule } from "../index";
import { TargetOrganizationsFilter } from "./TargetOrganizationsFilter";
import {
  defaultTargetOrganizationsSlice,
  type TargetOrganizationsSlice,
} from "./slice";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import { getChips, getCount } from "./chips";
import type { TargetOrganizationsOptions } from "./options";

export const targetOrganizationsModule: FilterModule<TargetOrganizationsSlice> =
  {
    key: "targetOrganizations",
    defaultSlice: defaultTargetOrganizationsSlice,
    Component: TargetOrganizationsFilter,
    toCompanyFilters,
    fromCompanyFilters,
    getChips,
    getCount,
  };

export type { TargetOrganizationsSlice, CachedCompany } from "./slice";
export { defaultTargetOrganizationsSlice } from "./slice";
export type { TargetOrganizationsOptions };
export { useTargetOrganizationsHydration } from "./useTargetOrganizationsHydration";
